import React from "react";
import imageIcon from "../../assets/images/Oval.png";
import { Switch } from "antd";

const TechnicianCard = ({ item }) => {
  return (
    <div class="TechnicianCard">
      <div class="row">
        <div class="col-3">
          {/* <img alt="" src={imageIcon} class="BillingStationOval" /> */}
        </div>
        <div class="col-6 pt-2 pl-0">
          <span class="OperatorName">
            Dr. {item.doctorname ? item.doctorname : "Anil Doctor1"}
            <span class="row OperatorType">
              {item.doctorstatus ? item.doctorstatus : "Cardiologist"}
            </span>
          </span>
        </div>
        <div class="col-2 pt-2">
          <div className="row">
            <Switch checkedChildren="In" unCheckedChildren="Out" />
          </div>
          <div className="row">
            <span className="operatorRoom">
              Room:
              {item.roomnumber.split(" ")[0]}
              {item.roomnumber.split(" ")[1]}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TechnicianCard;
